export default class LoginController {
  /*@ngInject*/
  constructor($location, $rootScope, installerAuth, i18n, $q, authChecker, wizardInfo, loginRedirect) {
    this.$rootScope = $rootScope;
    // this.$scope = $scope;
    this.$q = $q;
    this.i18n = i18n;
    this.authChecker = authChecker;
    this.installerAuth = installerAuth;
    this.$location = $location;
    this.wizardInfo = wizardInfo;
    this.formData = {};
    this.error = null;
    this.loading = false;
    this.showTokenLocation = false;

    this.tryToLogin();

    this.stopRedirectWatcher = loginRedirect.startRedirectWatcher();
  }

  tryToLogin() {
    return this.installerAuth.check(this.authChecker.check).
      then(() => {
        this.stopRedirectWatcher();
        this.$location.search('wizard_token', null);
        this.$location.path('/welcome');
        this.$location.replace();
        return this.$q.resolve('Successfully logged in');
      });
  }

  getInstallationType() {
    return this.wizardInfo.installationType;
  }

  login() {
    this.error = null;
    this.loading = true;

    return this.installerAuth.setWizardToken(this.formData.wizardToken).
      then(() => this.tryToLogin()).
      catch(error => {
        this.installerAuth.removeWizardToken();
        if (error && error.data && error.data.timeToWaitInMillis) {
          this.error = this.i18n(`Please wait ${ Math.round(error.data.timeToWaitInMillis / 1000) } seconds before next try`);
        } else {
          this.error = this.i18n('Invalid Wizard token');
        }
      }).finally(() => {
        this.loading = false;
      });
  }

  tokenPWD() {
    return this.installerAuth.getWizardTokenStorage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login__controller.js